<form [formGroup]="registerForm" (ngSubmit)="register()">
  <div class="auth-container">

    <img class="mt-5 mb-4" src="assets/monific/logo_monific_v2.svg" alt="">

    <div class="form-container pt-3">

      <div class="text-center">
        <h4 class="mb-1 fw-bold fs-20 cl-primary">Regístrate</h4>
      </div>

      <!-- ELEGIR TIPO DE REGISTRO -->
      <div
        class="d-flex justify-content-center align-items-center mb-4 mt-3 reg-container col-12 col-sm-12 col-md-12 col-lg-12 m-auto">
        <button mat-button class="action but-1" (click)="showDiv()" (click)="changeUserType('u')"
          [class.active]="userType === 'u'">Quiero invertir</button>
        <button mat-button class="action but-2" (click)="hideDiv()" (click)="changeUserType('d')"
          [class.active]="userType === 'd'">Quiero financiamiento</button>
      </div>

      <div *ngIf="userType === 'u' else noUser">
        <!-- CLAVE DE PROMOCIÓN -->
        <!--
          <div class="mnf-control mb-4">
            <p (click)="showPromotion = !showPromotion" class="cl-primary fs-12 text-right mb-1 cr-pointer">
              Código de promoción</p>
            <input class="mnf-input-form flat" *ngIf="showPromotion" formControlName="promo" placeholder="Promoción"
              mask="X{40}" [patterns]="promotionsPatern">
          </div>
        -->
        <!-- EMAIL -->
        <label class="mnf-control">
          <p class="mnf-control-label cl-primary mb-2">Correo electrónico</p>
          <input class="mnf-input-form flat" [ngClass]="{ error: email.touched && email.invalid }"
            formControlName="email" placeholder="usuario@correo.com" mask="E{100}"
            [specialCharacters]="['@', '-', '_', '.']" id="email" [patterns]="patternEmail"
            [dropSpecialCharacters]="false" autofocus>
          <div class="error-txt">
            <span class="text-red text-right" *ngIf="email.touched && email.invalid">Correo no válido</span>
          </div>
        </label>

        <label class="mnf-control">
          <p class="mnf-control-label cl-primary mb-2">Teléfono</p>
          <input class="mnf-input-form flat" [ngClass]="{ error: phone.touched && phone.invalid }"
            formControlName="phone" placeholder="00 0000 0000" mask="00 0000 0000" id="phone">
          <div class="error-txt">
            <span class="text-red text-right" *ngIf="phone.touched && phone.invalid">Teléfono no válido</span>
          </div>
        </label>
        <!-- CONTRASEÑA -->
        <label class="mnf-control form-password mb-2">
          <p class="mnf-control-label">Contraseña</p>

          <input class="mnf-input-form flat fw-bold" (focusout)="passwordBlur = false" placeholder="•••••••••"
            (focus)="passwordBlur = true" id="password" [type]="passwordFlag" aria-describedby="password"
            formControlName="password" data-bs-toggle="tooltip" trigger="focus" data-bs-placement="right"
            data-bs-html="true" />
          <i class="mnf-show cr-pointer fs-17" *ngIf="passwordFlag === 'password'" (click)="passwordFlag = 'text'"
            style="top: 55%"></i>
          <i class="mnf-hide cr-pointer fs-19" *ngIf="passwordFlag === 'text'" (click)="passwordFlag = 'password'"
            style="top: 54%"></i>
        </label>
        <p class="view-pass-p" *ngIf="passwordFlag === 'password'" (click)="passwordFlag = 'text'">Mostrar contraseña</p>
        <p class="view-pass-p" *ngIf="passwordFlag === 'text'" (click)="passwordFlag = 'password'">Ocultar contraseña</p>

        <div class="mb-2">
          <ul class="pe-0 ps-4 mt-0">

            <li class="fs-11 m-0" *ngIf="registerForm.controls.password?.errors?.minLengthRequired">
              Contiene al menos 8 caracteres
            </li>
            <li class="fs-11 m-0 text-success" *ngIf="!registerForm.controls.password?.errors?.minLengthRequired">
              Contiene al menos 8 caracteres
            </li>

            <li class="fs-11 m-0" *ngIf="registerForm.controls.password?.errors?.numericCharacterMissing">
              Contiene al menos un caracter numérico (0-9)
            </li>

            <li class="fs-11 m-0 text-success" *ngIf="!registerForm.controls.password?.errors?.numericCharacterMissing">
              Contiene al menos un caracter numérico (0-9)
            </li>

            <li class="fs-11 m-0" *ngIf="registerForm.controls.password?.errors?.lowercaseMissing">
              Contiene al menos un caracter alfabético en minúscula (a-z)
            </li>

            <li class="fs-11 m-0" *ngIf="registerForm.controls.password?.errors?.uppercaseMissing">
              Contiene al menos un caracter alfabético en mayúscula (A-Z)
            </li>

            <li class="fs-11 m-0 text-success" *ngIf="!registerForm.controls.password?.errors?.lowercaseMissing">
              Contiene al menos un caracter alfabético en minúscula (a-z)
            </li>

            <li class="fs-11 m-0 text-success" *ngIf="!registerForm.controls.password?.errors?.uppercaseMissing">
              Contiene al menos un caracter alfabético en mayúscula (A-Z)
            </li>

            <li class="fs-11 m-0" *ngIf="registerForm.controls.password?.errors?.specialCharacterMissing">
              Contiene al menos un caracter especial (!&#64;#$)
            </li>

            <li class="fs-11 m-0 text-success" *ngIf="!registerForm.controls.password?.errors?.specialCharacterMissing">
              Contiene al menos un caracter especial (!&#64;#$)
            </li>

            <li class="fs-11 m-0 text-danger" *ngIf="registerForm.controls.password?.errors?.containsMonific">
              No debe incluir las palabra <strong>"monific"</strong>
            </li>

            <li class="fs-11 m-0 text-danger fw-bold"
              *ngIf="registerForm.controls.password?.errors?.sequentialCharacters || registerForm.controls.password?.errors?.consecutiveAlphabet">
              No debe tener mas de 3 caracteres secuenciales o identicos consecutivos (ej. abcd)
            </li>

            <li class="fs-11 m-0 text-danger fw-bold"
              *ngIf="registerForm.controls.password?.errors?.consecutiveNumbers">
              No debe tener mas de 3 caracteres numericos o identicos consecutivos (ej. 1234)
            </li>

            <li class="fs-11 m-0 text-danger fw-bold" *ngIf="registerForm.controls.password?.errors?.emailViolation">
              No debe incluir tu correo electrónico
            </li>

          </ul>
        </div>


        <label class="mnf-control form-password mb-2">
          <p class="mnf-control-label">Confirmar contraseña</p>

          <input class="mnf-input-form flat fw-bold" id="confirmPw" type="password" aria-describedby="confirmPassword"
            formControlName="confirmPassword" placeholder="•••••••••" [type]="passwordFlag2" />
          <i class="mnf-show cr-pointer fs-17" *ngIf="passwordFlag2 === 'password'" (click)="passwordFlag2 = 'text'"
            style="top: 55%"></i>
          <i class="mnf-hide cr-pointer fs-19" *ngIf="passwordFlag2 === 'text'" (click)="passwordFlag2 = 'password'"
            style="top: 54%"></i>
          <div class="error-txt">
            <span *ngIf="registerForm.errors?.notMatchPass && registerForm.controls.password.value
           && registerForm.controls.confirmPassword.touched" class="text-red small text-right">
              La contraseñas no coinciden
            </span>
          </div>
        </label>
        <p class="view-pass-p" *ngIf="passwordFlag2 === 'password'" (click)="passwordFlag2 = 'text'">Mostrar contraseña</p>
        <p class="view-pass-p" *ngIf="passwordFlag2 === 'text'" (click)="passwordFlag2 = 'password'">Ocultar contraseña</p>

        <div class="mnf-control mb-4 mt-4">
          <p (click)="showReferred = !showReferred" class="cl-primary fs-12 text-right mb-1 cr-pointer">
            Código de referido</p>
          <input class="mnf-input-form flat" *ngIf="showReferred" formControlName="referred" placeholder="Código"
            mask="X{40}" [patterns]="referredPatern">
        </div>

        <div class="d-flex mt-2">
          <div class="form-check my-auto">
            <input class="form-check-input" formControlName="terms" type="checkbox" id="terms">
          </div>
          <label class="form-check-label" for="terms">
            <p class="text-left fs-12 cl-gray2 mb-0 pt-1">
              Estoy de acuerdo con los <span class="fw-sbold cl-primary cr-pointer" (click)="goToTerms()"> Términos y
                Condiciones</span> y con el tratamiento de mis datos según el<span
                class="fw-sbold cl-primary cr-pointer" (click)="goToWarning()"> Aviso de privacidad</span></p>
          </label>
        </div>

        <div class="d-flex mt-2 mb-3">
          <div class="form-check my-auto">
            <input class="form-check-input" formControlName="mailProm" type="checkbox" id="mailProm">
          </div>
          <label class="form-check-label" for="mailProm">
            <p class="fs-12 cl-gray2 mb-0 pt-1">
              Estoy de acuerdo que mis datos personales sean utilizados para fines de mercadotecnia y/o publicitarios.
            </p>
          </label>
        </div>

        <div class="w-100 text-center">
          <button class="mt-4 btn-primary-c" type="submit" mat-button="mat-button" [disabled]="registerForm.invalid">
            Continuar</button>
        </div>
      </div>

      <ng-template #noUser>
        <div class="col-11 m-auto">
          <p class="mb-4 cl-black fs-15 text-justify"> Si buscas un financiamiento para tu propiedad inmobiliaria, da
            clic a continuación para completar la solicitud: </p>
          <button mat-button class="m-auto text-center d-block btn-primary mb-3"
            (click)="goTo('https://docs.google.com/forms/d/e/1FAIpQLSdGeyG1Zt399HllwZlOahpiHbnLcLl-wnlGoet4FuehvxasMA/viewform')">Iniciar
            solicitud</button>
        </div>
      </ng-template>


    </div>

    <p class="text-center mb-4 mt-4 fs-15 cl-black">Si ya tienes una cuenta <br> <a routerLink="/"
        class="cr-pointer mt-4"><span class="cl-secondary text-decoration-underline fw-sbold ms-1">Inicia sesión
          aquí <img class="icon ms-2" src="https://static.monific.com/assets/assets-app/img/wallet/arrow-icon.svg" alt=""></span></a></p>


  </div>
</form>